import { openHomepage } from "@actions/openHomepage";
import { store } from "@store/store";
import { updateLoader } from "@store/slices/config";
import { setToastData } from "@store/slices/globalState";

const DEFAULT_HOMEPAGE_LINK = "https://ackoapp.onelink.me/Tlwi/sngilefw";

interface MarkDashcamAsDeliveredArgs {
  order_id?: string;
  link?: string;
}

export const markDashcamAsDelivered = async ({
  order_id,
  link
}: MarkDashcamAsDeliveredArgs = {}) => {
  if (!order_id) {
    store?.dispatch(
      setToastData({
        toastMessage: "Something went wrong",
        toastMessageType: "error"
      })
    );
    return;
  }

  store?.dispatch(updateLoader(true));

  try {
    const response = await fetch(
      `${process.env.SDUI_API_SERVICE}/mark-dashcam-delivered`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ order_id })
      }
    );

    if (!response.ok) {
      throw new Error("Unable to mark Dashcam as delivered");
    }

    openHomepage({ link: link || DEFAULT_HOMEPAGE_LINK });
  } catch {
    store?.dispatch(updateLoader(false));
    store?.dispatch(
      setToastData({
        toastMessage: "Something went wrong",
        toastMessageType: "error"
      })
    );
    throw new Error("Unable to mark Dashcam as delivered");
  }
};
